export default function(state = [], action){
    switch(action.type){
        case "SET_AUTO_DIALER_CALLS":
            return action.payload;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/autoDialerCalls.js